const topics = [
  { label: '#玫瑰的故事大结局', count: '128万讨论', hot: true },
  { label: '#长相思第二季', count: '96万讨论', hot: true },
  { label: '#唐朝诡事录', count: '85万讨论', hot: true },
  { label: '#韩剧推荐', count: '72万讨论', hot: false },
  { label: '#国产剧天花板', count: '68万讨论', hot: false },
  { label: '#暑假追剧指南', count: '63万讨论', hot: false },
  { label: '#你比星光美丽', count: '57万讨论', hot: false },
  { label: '#古装剧安利', count: '51万讨论', hot: false },
  { label: '#好搭档韩剧', count: '48万讨论', hot: false },
  { label: '#悬疑剧推荐', count: '42万讨论', hot: false },
  { label: '#电视剧在线观看', count: '39万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          话题广场
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          热门话题讨论，看看大家都在聊什么
        </p>
        <div className="max-w-3xl mx-auto flex flex-wrap justify-center gap-3">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 ${
                item.hot
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 hover:bg-white border border-background-200/60'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
              <span className={`text-xs whitespace-nowrap ${
                item.hot ? 'text-white/75' : 'text-foreground-500'
              }`}>
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}